import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';
import { RE_PROJECTS_ENDPOINTS } from 'src/app/core/api/endpoints/re-projects.endpoints';
import { BUTTON_LOADING_ID } from 'src/app/shared/global/http-context-tokens';

@Injectable({
  providedIn: 'root'
})
export class ReProjectsService {
  private api = inject(ApiService);

  // Get all RE projects with optional params
  getREProjects(params?: any): Observable<any> {
    return this.api.get(RE_PROJECTS_ENDPOINTS.V2.REAL_ESTATE, { params });
  }

  // Get single RE project details
  getREProjectDetails(id: number): Observable<any> {
    return this.api.get(RE_PROJECTS_ENDPOINTS.V2.REAL_ESTATE_DETAIL(id));
  }

  // Create new RE project
  createREProject(data: FormData, buttonId?: string): Observable<any> {
    const options = buttonId 
      ? { context: new HttpContext().set(BUTTON_LOADING_ID, buttonId) }
      : {};
    return this.api.post(RE_PROJECTS_ENDPOINTS.V2.REAL_ESTATE, data, options);
  }

  // Update RE project
  updateREProject(id: number, data: FormData, buttonId?: string): Observable<any> {
    const options = buttonId 
      ? { context: new HttpContext().set(BUTTON_LOADING_ID, buttonId) }
      : {};
    return this.api.put(RE_PROJECTS_ENDPOINTS.V2.REAL_ESTATE_DETAIL(id), data, options);
  }

  // Delete RE project(s)
  deleteREProjects(projectIds: number[]): Observable<any> {
    return this.api.delete(RE_PROJECTS_ENDPOINTS.V2.REAL_ESTATE_DELETE, { body: projectIds });
  }

  // Get RE project types
  getREProjectTypes(): Observable<any> {
    return this.api.get(RE_PROJECTS_ENDPOINTS.V2.REAL_ESTATE_TYPES);
  }

  // Get RE project status choices
  getREProjectStatus(): Observable<any> {
    return this.api.get(RE_PROJECTS_ENDPOINTS.V2.REAL_ESTATE_STATUS);
  }
  
  // Get RE project source types
  getREProjectSourceTypes(): Observable<any> {
    return this.api.get(RE_PROJECTS_ENDPOINTS.V2.REAL_ESTATE_SOURCES);
  }

  // Get RE projects by company
  getCompanyREProjects(companyId: number, params?: any): Observable<any> {
    return this.api.get(RE_PROJECTS_ENDPOINTS.V2.REAL_ESTATE_COMPANY(companyId), { params });
  }

  // Get contracts for a specific RE project
  getREProjectContracts(projectId: number, params?: any): Observable<any> {
    return this.api.get(RE_PROJECTS_ENDPOINTS.V2.REAL_ESTATE_CONTRACTS(projectId), { params });
  }
}
